import { render, staticRenderFns } from "./solicitud-reporte-comunitario-resumen.vue?vue&type=template&id=0adda166&"
import script from "./solicitud-reporte-comunitario-resumen.vue?vue&type=script&lang=ts&"
export * from "./solicitud-reporte-comunitario-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports